import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { createColumnHelper } from "@tanstack/react-table"
import { ApiEndpoints, reqGetNew } from "../../../../config/apiClient"
import DataTable from "../../../../components/dataTable/DataTable"

function NFSeServicosMunPage() {
    const [servicos, setServicos] = useState<iNfServicoMunDto[]>([])

    useEffect(() => {
        document.title = "NFSe Serviços Municipais | OB PORTUS"

        listarDados()
    }, [])

    async function listarDados() {
        const api = await reqGetNew(ApiEndpoints.nfseServicosMunicipaisListar)

        if (api.status === 200) {
            const clientesAux:iNfServicoMunDto[] = api.data
            setServicos(clientesAux)
        }
    }

    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = servicos[idx]
        const link = `/nfse/servico_mun?id=${reg.id}`

        if (event.button === 1) {
            window.open(link)
        }
    }

    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = servicos[idx]
        const link = `/nfse/servico_mun?id=${reg.id}`

        if (event.button === 0) {
            window.location.assign(link)
        }
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <h1 id="titleMain">NF Serviços Municipais</h1>
                <div className="div-row">
                    <Button onClick={() => {
                        window.location.assign(`/nfse/servico_mun`)
                    }}>Cadastrar</Button>
                </div>
            </div>
            <br></br>
            {<DataTable dados={servicos} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />}
        </div>
    )
}

export default NFSeServicosMunPage

export interface iNfServicoMunDto {
    id:number | null
    cidade_cod:any
    servico_cod:any
    servico_cod_mun:string
    servico_descricao:string
}

const columnHelper = createColumnHelper<iNfServicoMunDto>()

const defaultColumns = [
    columnHelper.accessor('id', {
        header: '#ID',
        size: 10,
    }),
    columnHelper.accessor(row => `${row.servico_cod_mun} - ${row.servico_descricao}`, {
        header: 'Descrição',
        size: 300,
    }),
    columnHelper.accessor(row => `${row.servico_cod.servico_cod}`, {
        header: 'Cod. Serviço',
        size: 50,
    }),
    columnHelper.accessor(row => `${row.cidade_cod.nome} / ${row.cidade_cod.uf}`, {
        header: 'Cidade',
        size: 150,
    }),
]

const defaultOrder:any = []